// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"c1d1fd16","363":"84d3dcfa","387":"2a32234c","473":"be5bc933","487":"62ebe141","519":"9f23b8b6","656":"887b8e86","819":"f7259ab4","821":"49d513eb","869":"0c769aae","960":"a1fecdbf"}[chunkId] + ".chunk.js";
};